module.exports = __webpack_public_path__ + "img/undraw_join_re_w1lh.cf15800b.svg";